const UNEXPECTED_ERROR =
    'Unexpected server error.  Please contact Player Services.';

// note this list is not complete
// i left out many of the internal only errors
const errorMessages = {
    // PAM Errors
    _VALIDATION: 'Input validation error',
    _AUTHENTICATION: 'Authentication unsuccessful!',
    _AUTHORIZATION: 'Authorization unsuccessful!  ',
    _BAD_LOGIN: 'Authentication unsuccessful!',
    _NOT_CONFIRMED:
        'Please click the account verification link inside your registration email prior to logging in for the first time.',
    _NO_ACTION_CANCEL: 'Player action cannot be cancelled.',
    _NOT_TESTABLE: UNEXPECTED_ERROR,
    _BAD_ACCT_TYPE: UNEXPECTED_ERROR,
    _TOO_MANY_TRIES: 'Too many login attempt failures.',
    _LOGIN_LOCKED:
        'Account login locked due to repeated login failures.  Please contact Player Services to unlock your account.',
    _MISSING_2FA: UNEXPECTED_ERROR,
    _EXPIRED_2FA: UNEXPECTED_ERROR,
    _CLASS_METHOD: UNEXPECTED_ERROR,
    _HTTP_FAIL: UNEXPECTED_ERROR,
    _NO_TOS_PLAYER: UNEXPECTED_ERROR,
    _BAD_FORGOT_PASSWORD:
        'Password not reset.  Please contact Player Services.',
    _MISSING_PLAYER: UNEXPECTED_ERROR,
    _NO_PLAYER_ACTION: UNEXPECTED_ERROR,
    _UPS_FAIL: UNEXPECTED_ERROR,
    _PASSWORD_XDIFF:
        'There was an error resetting your password. New passwords cannot match existing password.',
    _RECENT_PASSWORD: 'Your last 10 passwords must not repeat.',
    _MINIMUM_AGE: 'You must be at least 18 years old to use this site.',
    _BAD_ADDRESS: 'You must enter a valid shipping address.',

    // Entry Errors
    _INVALID_TICKET: 'Invalid ticket.',
    _PLAYER_LOCKOUT: 'This player has been locked out of ticket entry',

    //  Global Errors
    _UNKNOWN: UNEXPECTED_ERROR,
    _QUERY: UNEXPECTED_ERROR,
    _NOT_FOUND_MODEL: UNEXPECTED_ERROR,
};

export const errorMessage = (code, fallback) => {
    return errorMessages[code] || fallback || UNEXPECTED_ERROR;
};

export default errorMessages;
